import { CoinIcon } from '../../../../assets/icons/CoinIcon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Icon } from '../../../../core/components/atoms/Icon';

const CardScore = ({
  score,
  onClose,
}: {
  score: boolean | (string | number)[] | string | number;
  onClose?: () => void;
}) => {
  const scores = Array.isArray(score) ? score : [score];

  const scoreFormatted = scores.join(' a ');

  const handleClose = (e: any) => {
    e?.stopPropagation();
    e?.preventDefault();
    onClose?.();
  };
  return (
    <div className='w-full'>
      <div onClick={(e) => handleClose(e)}>
        <Icon
          Icon={'close'}
          type='material'
          className='relative left-[225px] top-[50px] cursor-pointer text-sm text-mono-color-white'
        />
      </div>
      <div className='relative top-[15px] z-10 mx-auto w-fit'>
        <CoinIcon />
      </div>
      <div className='flex flex-col items-center justify-center rounded-lg border-mono-color-black bg-button-color-tertiary-default pb-5 pt-8'>
        <Typography
          title='h5'
          className='!text-h5 font-bold text-brand-color-primary-lighter'
        >
          Você fez
        </Typography>
        <Typography
          type='title'
          title='h2'
          className='!text-h2 font-bold text-mono-color-white'
        >
          {scoreFormatted} pontos
        </Typography>
      </div>
    </div>
  );
};

export default CardScore;
